export default () => {
    'use strict';
    const toggleChatButtons = document.querySelectorAll('.intercom-toggle ');
    for (const btn of toggleChatButtons) {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (window.hasOwnProperty('Intercom')) {
                // @ts-ignore
                window.Intercom('show');
            }
        })
    }
}
